module["exports"] = [
  "gmail.com",
  "seznam.cz",
  "centrum.cz",
  "volny.cz",
  "atlas.cz"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/cz/internet/free_email.js
// module id = 225
// module chunks = 0